import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../config/axiosBaseQuery';
import { BudgetTemplate, CreateBudgetTemplateRequest, UpdateBudgetTemplateRequest } from './budgetTemplatesTypes';

export const budgetTemplatesApi = createApi({
  reducerPath: 'budgetTemplatesApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['BudgetTemplates'],
  endpoints: (builder) => ({
    getBudgetTemplates: builder.query<BudgetTemplate[], void>({
      query: () => ({
        url: '/api/budgets/templates',
        method: 'GET',
      }),
      providesTags: ['BudgetTemplates'],
    }),

    getBudgetTemplateById: builder.query<BudgetTemplate, string>({
      query: (id) => ({
        url: `/api/budgets/templates/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'BudgetTemplates', id }],
    }),

    createBudgetTemplate: builder.mutation<BudgetTemplate, CreateBudgetTemplateRequest>({
      query: (budgetTemplate) => ({
        url: '/api/budgets/templates',
        method: 'POST',
        data: budgetTemplate,
      }),
      invalidatesTags: ['BudgetTemplates'],
    }),

    updateBudgetTemplate: builder.mutation<BudgetTemplate, { id: string; budgetTemplate: UpdateBudgetTemplateRequest }>({
      query: ({ id, budgetTemplate }) => ({
        url: `/api/budgets/templates/${id}`,
        method: 'PUT',
        data: budgetTemplate,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'BudgetTemplates', id }, 'BudgetTemplates'],
    }),

    deleteBudgetTemplate: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/budgets/templates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['BudgetTemplates'],
    }),
  }),
});

export const {
  useGetBudgetTemplatesQuery,
  useGetBudgetTemplateByIdQuery,
  useCreateBudgetTemplateMutation,
  useUpdateBudgetTemplateMutation,
  useDeleteBudgetTemplateMutation,
} = budgetTemplatesApi;
